module.exports = __webpack_public_path__ + "static/media/marker-icon.80beebfc.svg";